import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import DeleteMediaBtn from '../../src/media/DeleteMediaBtn.jsx';

let domDeleteEl = document.querySelectorAll('.DeleteMediaBtn');
let media;
if (preloaded.video) media = preloaded.video;
if (preloaded.picture) media = preloaded.picture;

if (domDeleteEl) {
  domDeleteEl.forEach( el => {
    ReactDOM.render(<DeleteMediaBtn media={media} el={el} />, el);
  });
}